// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { ClientImportLookup_IntegrationClientFragment } from '../../../pages/import/bulkImport/graphql/ClientImportLookup.generated';
import { gql } from '@apollo/client';
import { ClientImportLookup_IntegrationClientFragmentDoc } from '../../../pages/import/bulkImport/graphql/ClientImportLookup.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type EntityImportTable_IntegrationEntityChildFragment = { __typename?: 'IntegrationEntity', id: string, name: string, externalKind?: Types.IntegrationEntityExternalKind | null, value?: CurrencyUSD | null };

export type EntityImportTable_IntegrationEntityFragment = { __typename?: 'IntegrationEntity', id: string, name: string, externalKind?: Types.IntegrationEntityExternalKind | null, value?: CurrencyUSD | null, childEntities?: Array<(
    { __typename?: 'IntegrationEntity', childEntities?: Array<(
      { __typename?: 'IntegrationEntity', childEntities?: Array<(
        { __typename?: 'IntegrationEntity', childEntities?: Array<(
          { __typename?: 'IntegrationEntity' }
          & EntityImportTable_IntegrationEntityChildFragment
        )> | null }
        & EntityImportTable_IntegrationEntityChildFragment
      )> | null }
      & EntityImportTable_IntegrationEntityChildFragment
    )> | null }
    & EntityImportTable_IntegrationEntityChildFragment
  )> | null, integrationClient?: (
    { __typename?: 'IntegrationClient' }
    & ClientImportLookup_IntegrationClientFragment
  ) | null };

export type EntityImportTable_HouseholdFragment = { __typename?: 'Household', id: string, displayName: string, integrationClients?: Array<{ __typename?: 'IntegrationClient', id: string }> | null, possiblePrimaryClients: Array<{ __typename?: 'ClientProfile', id: string, displayName: string }>, possibleGrantors: Array<{ __typename?: 'ClientProfile', id: string, displayName: string, legalName: string, isPrimary: boolean }> };

export type AllHouseholdsEntityImportTableQueryVariables = Types.Exact<{
  householdsLike: Types.HouseholdWhereInput;
  integrationClientKind?: Types.InputMaybe<Types.IntegrationClientKind>;
}>;


export type AllHouseholdsEntityImportTableQuery = { __typename?: 'Query', households: { __typename?: 'HouseholdConnection', edges?: Array<{ __typename?: 'HouseholdEdge', node?: (
        { __typename?: 'Household' }
        & EntityImportTable_HouseholdFragment
      ) | null } | null> | null }, integrationEntities: { __typename?: 'IntegrationEntityConnection', edges?: Array<{ __typename?: 'IntegrationEntityEdge', node?: (
        { __typename?: 'IntegrationEntity' }
        & EntityImportTable_IntegrationEntityFragment
      ) | null } | null> | null } };

export type SingleHouseholdEntityImportTableQueryVariables = Types.Exact<{
  householdsLike: Types.HouseholdWhereInput;
  integrationClientKind?: Types.InputMaybe<Types.IntegrationClientKind>;
}>;


export type SingleHouseholdEntityImportTableQuery = { __typename?: 'Query', households: { __typename?: 'HouseholdConnection', edges?: Array<{ __typename?: 'HouseholdEdge', node?: (
        { __typename?: 'Household' }
        & EntityImportTable_HouseholdFragment
      ) | null } | null> | null }, integrationEntities: { __typename?: 'IntegrationEntityConnection', edges?: Array<{ __typename?: 'IntegrationEntityEdge', node?: (
        { __typename?: 'IntegrationEntity' }
        & EntityImportTable_IntegrationEntityFragment
      ) | null } | null> | null } };

export type InferEntityKindsQueryVariables = Types.Exact<{
  input: Array<Types.InferEntityKindInput> | Types.InferEntityKindInput;
}>;


export type InferEntityKindsQuery = { __typename?: 'Query', inferEntityKinds: Array<{ __typename?: 'InferEntityKindOutput', id: string, entityName: string, entityKind: Types.EntityKind }> };

export const Operations = {
  Query: {
    AllHouseholdsEntityImportTable: 'AllHouseholdsEntityImportTable' as const,
    SingleHouseholdEntityImportTable: 'SingleHouseholdEntityImportTable' as const,
    InferEntityKinds: 'InferEntityKinds' as const
  },
  Fragment: {
    EntityImportTable_IntegrationEntityChild: 'EntityImportTable_IntegrationEntityChild' as const,
    EntityImportTable_IntegrationEntity: 'EntityImportTable_IntegrationEntity' as const,
    EntityImportTable_Household: 'EntityImportTable_Household' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const EntityImportTable_IntegrationEntityChildFragmentDoc = gql`
    fragment EntityImportTable_IntegrationEntityChild on IntegrationEntity {
  id
  name
  externalKind
  value
}
    `;
export const EntityImportTable_IntegrationEntityFragmentDoc = gql`
    fragment EntityImportTable_IntegrationEntity on IntegrationEntity {
  id
  name
  externalKind
  value
  childEntities {
    ...EntityImportTable_IntegrationEntityChild
    childEntities {
      ...EntityImportTable_IntegrationEntityChild
      childEntities {
        ...EntityImportTable_IntegrationEntityChild
        childEntities {
          ...EntityImportTable_IntegrationEntityChild
        }
      }
    }
  }
  integrationClient {
    ...ClientImportLookup_IntegrationClient
  }
}
    ${EntityImportTable_IntegrationEntityChildFragmentDoc}
${ClientImportLookup_IntegrationClientFragmentDoc}`;
export const EntityImportTable_HouseholdFragmentDoc = gql`
    fragment EntityImportTable_Household on Household {
  id
  displayName
  integrationClients {
    id
  }
  possiblePrimaryClients {
    id
    displayName
  }
  possibleGrantors {
    id
    displayName
    legalName
    isPrimary
  }
}
    `;
export const AllHouseholdsEntityImportTableDocument = gql`
    query AllHouseholdsEntityImportTable($householdsLike: HouseholdWhereInput!, $integrationClientKind: IntegrationClientKind) {
  households(
    where: $householdsLike
    orderBy: {direction: DESC, field: created_at}
  ) {
    edges {
      node {
        ...EntityImportTable_Household
      }
    }
  }
  integrationEntities(
    first: 500
    where: {and: [{hasEntities: false}, {hasParentEntity: false}, {hasIntegrationClientWith: [{kind: $integrationClientKind}]}]}
    orderBy: {direction: DESC, field: created_at}
  ) {
    edges {
      node {
        ...EntityImportTable_IntegrationEntity
      }
    }
  }
}
    ${EntityImportTable_HouseholdFragmentDoc}
${EntityImportTable_IntegrationEntityFragmentDoc}`;

/**
 * __useAllHouseholdsEntityImportTableQuery__
 *
 * To run a query within a React component, call `useAllHouseholdsEntityImportTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllHouseholdsEntityImportTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllHouseholdsEntityImportTableQuery({
 *   variables: {
 *      householdsLike: // value for 'householdsLike'
 *      integrationClientKind: // value for 'integrationClientKind'
 *   },
 * });
 */
export function useAllHouseholdsEntityImportTableQuery(baseOptions: Apollo.QueryHookOptions<AllHouseholdsEntityImportTableQuery, AllHouseholdsEntityImportTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllHouseholdsEntityImportTableQuery, AllHouseholdsEntityImportTableQueryVariables>(AllHouseholdsEntityImportTableDocument, withFetchPolicyContext(options));
      }
export function useAllHouseholdsEntityImportTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllHouseholdsEntityImportTableQuery, AllHouseholdsEntityImportTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllHouseholdsEntityImportTableQuery, AllHouseholdsEntityImportTableQueryVariables>(AllHouseholdsEntityImportTableDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useAllHouseholdsEntityImportTableSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllHouseholdsEntityImportTableQuery, AllHouseholdsEntityImportTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllHouseholdsEntityImportTableQuery, AllHouseholdsEntityImportTableQueryVariables>(AllHouseholdsEntityImportTableDocument, withFetchPolicyContext(options));
        }
export type AllHouseholdsEntityImportTableQueryHookResult = ReturnType<typeof useAllHouseholdsEntityImportTableQuery>;
export type AllHouseholdsEntityImportTableLazyQueryHookResult = ReturnType<typeof useAllHouseholdsEntityImportTableLazyQuery>;
export type AllHouseholdsEntityImportTableSuspenseQueryHookResult = ReturnType<typeof useAllHouseholdsEntityImportTableSuspenseQuery>;
export type AllHouseholdsEntityImportTableQueryResult = Apollo.QueryResult<AllHouseholdsEntityImportTableQuery, AllHouseholdsEntityImportTableQueryVariables>;
export const SingleHouseholdEntityImportTableDocument = gql`
    query SingleHouseholdEntityImportTable($householdsLike: HouseholdWhereInput!, $integrationClientKind: IntegrationClientKind) {
  households(
    where: $householdsLike
    orderBy: {direction: DESC, field: created_at}
  ) {
    edges {
      node {
        ...EntityImportTable_Household
      }
    }
  }
  integrationEntities(
    first: 500
    where: {and: [{not: {hasEntitiesWith: {hasHouseholdWith: [$householdsLike]}}}, {hasParentEntity: false}, {hasIntegrationClientWith: [{kind: $integrationClientKind}, {hasClientHouseholdsWith: [$householdsLike]}]}]}
    orderBy: {direction: DESC, field: created_at}
  ) {
    edges {
      node {
        ...EntityImportTable_IntegrationEntity
      }
    }
  }
}
    ${EntityImportTable_HouseholdFragmentDoc}
${EntityImportTable_IntegrationEntityFragmentDoc}`;

/**
 * __useSingleHouseholdEntityImportTableQuery__
 *
 * To run a query within a React component, call `useSingleHouseholdEntityImportTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleHouseholdEntityImportTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleHouseholdEntityImportTableQuery({
 *   variables: {
 *      householdsLike: // value for 'householdsLike'
 *      integrationClientKind: // value for 'integrationClientKind'
 *   },
 * });
 */
export function useSingleHouseholdEntityImportTableQuery(baseOptions: Apollo.QueryHookOptions<SingleHouseholdEntityImportTableQuery, SingleHouseholdEntityImportTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleHouseholdEntityImportTableQuery, SingleHouseholdEntityImportTableQueryVariables>(SingleHouseholdEntityImportTableDocument, withFetchPolicyContext(options));
      }
export function useSingleHouseholdEntityImportTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleHouseholdEntityImportTableQuery, SingleHouseholdEntityImportTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleHouseholdEntityImportTableQuery, SingleHouseholdEntityImportTableQueryVariables>(SingleHouseholdEntityImportTableDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useSingleHouseholdEntityImportTableSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SingleHouseholdEntityImportTableQuery, SingleHouseholdEntityImportTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SingleHouseholdEntityImportTableQuery, SingleHouseholdEntityImportTableQueryVariables>(SingleHouseholdEntityImportTableDocument, withFetchPolicyContext(options));
        }
export type SingleHouseholdEntityImportTableQueryHookResult = ReturnType<typeof useSingleHouseholdEntityImportTableQuery>;
export type SingleHouseholdEntityImportTableLazyQueryHookResult = ReturnType<typeof useSingleHouseholdEntityImportTableLazyQuery>;
export type SingleHouseholdEntityImportTableSuspenseQueryHookResult = ReturnType<typeof useSingleHouseholdEntityImportTableSuspenseQuery>;
export type SingleHouseholdEntityImportTableQueryResult = Apollo.QueryResult<SingleHouseholdEntityImportTableQuery, SingleHouseholdEntityImportTableQueryVariables>;
export const InferEntityKindsDocument = gql`
    query InferEntityKinds($input: [InferEntityKindInput!]!) {
  inferEntityKinds(input: $input) {
    id
    entityName
    entityKind
  }
}
    `;

/**
 * __useInferEntityKindsQuery__
 *
 * To run a query within a React component, call `useInferEntityKindsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInferEntityKindsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInferEntityKindsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInferEntityKindsQuery(baseOptions: Apollo.QueryHookOptions<InferEntityKindsQuery, InferEntityKindsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InferEntityKindsQuery, InferEntityKindsQueryVariables>(InferEntityKindsDocument, withFetchPolicyContext(options));
      }
export function useInferEntityKindsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InferEntityKindsQuery, InferEntityKindsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InferEntityKindsQuery, InferEntityKindsQueryVariables>(InferEntityKindsDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useInferEntityKindsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InferEntityKindsQuery, InferEntityKindsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InferEntityKindsQuery, InferEntityKindsQueryVariables>(InferEntityKindsDocument, withFetchPolicyContext(options));
        }
export type InferEntityKindsQueryHookResult = ReturnType<typeof useInferEntityKindsQuery>;
export type InferEntityKindsLazyQueryHookResult = ReturnType<typeof useInferEntityKindsLazyQuery>;
export type InferEntityKindsSuspenseQueryHookResult = ReturnType<typeof useInferEntityKindsSuspenseQuery>;
export type InferEntityKindsQueryResult = Apollo.QueryResult<InferEntityKindsQuery, InferEntityKindsQueryVariables>;